var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGswift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGswift0)",
    d: "m3.429 16.714l5.357-5.76l1.071.523l-1.607 1.834L11.2 12l1.337.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.572 16.714L15.75 11.74l2.679-1.453l-3.215-3H8.786l-3.214 3zM9.322 8.143h5.357l1.877 1.761l-1.877.784l-.965-.83H9.857l2.357.856h1.072l2.464 2.597l-8.306-3.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    fillOpacity: 0.6,
    d: "m16.153 11.541l-.977-1.058l-.497.205l-.3-.287l1.371 1.338z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGswift0",
    x1: 16.038,
    x2: 6.416,
    y1: 8.142,
    y2: 17.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGswift);
export default __webpack_public_path__ + "static/media/gswift.31fa6a38223d55e753e55278b5555f96.svg";
export { ForwardRef as ReactComponent };